import { Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import color from 'src/theme/color';

export const ResponseCard = styled(Box)<{ $isSuccess: boolean }>(
    ({ $isSuccess }) => ({
        width: '17%',
        background: color.blackLight,
        borderRadius: '8px',
        padding: '40px 50px',
        position: 'relative',
        color: color.white,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        minHeight: '400px',
        justifyContent: 'center',
        border: $isSuccess
            ? `2px solid ${color.green || '#4caf50'}`
            : `2px solid ${color.red || '#f44336'}`,
        boxShadow: $isSuccess
            ? `0 0 20px ${color.lightGreen || 'rgba(76, 175, 80, 0.3)'}`
            : `0 0 20px ${color.lightOrangyRed || 'rgba(244, 67, 54, 0.3)'}`
    })
);

export const StatusIcon = styled(Box)<{ $isSuccess: boolean }>(
    ({ $isSuccess }) => ({
        fontSize: '64px',
        marginBottom: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        backgroundColor: $isSuccess
            ? `${color.green || '#4caf50'}20`
            : `${color.red || '#f44336'}20`,
        border: $isSuccess
            ? `2px solid ${color.green || '#4caf50'}`
            : `2px solid ${color.red || '#f44336'}`
    })
);

export const StatusTitle = styled(Typography)<{ $isSuccess: boolean }>(
    ({ $isSuccess }) => ({
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '16px',
        color: $isSuccess ? color.green || '#4caf50' : color.red || '#f44336'
    })
);

export const StatusMessage = styled(Typography)({
    fontSize: '16px',
    lineHeight: '1.5',
    marginBottom: '32px',
    color: color.white,
    opacity: 0.9
});

export const SuccessDetails = styled(Box)({
    width: '100%',
    marginBottom: '16px'
});

export const ErrorDetails = styled(Box)({
    width: '100%',
    marginBottom: '16px'
});

export const ActionButton = styled(Button)(({ theme }) => ({
    backgroundColor: color.yellow,
    color: color.white,
    fontWeight: 500,
    borderRadius: theme.spacing(3),
    textTransform: 'none',
    padding: theme.spacing(1.5, 3),
    minWidth: '200px',
    '&:hover': {
        color: color.yellow,
        backgroundColor: color.yellowTransparent
    },
    '&.Mui-disabled': {
        backgroundColor: `${color.yellow} !important`,
        color: `${color.white} !important`,
        opacity: 0.6
    }
}));

export const ButtonContentBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
    height: '100%'
});

export const ButtonTextBox = styled(Box)<{ $isHovered: boolean }>(
    ({ $isHovered }) => ({
        position: 'relative',
        transition: 'transform 0.3s ease-in-out',
        transform: $isHovered ? 'translateX(-8px)' : 'translateX(0)'
    })
);

export const ButtonIconBox = styled(Box)<{ $isHovered: boolean }>(
    ({ $isHovered }) => ({
        marginLeft: '8px',
        opacity: $isHovered ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        right: 'calc(50% - 75px)'
    })
);
